import * as React from 'react';
import {Button} from "antd";
import usePortalService from '../../services/PortalService';
import { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { StyledModal } from './StyledModal';

type CoverLetterProps = {
  isOpen: boolean;
  close: () => void;
  vacancyId: number;
  setReaction: (setReaction: boolean) => void;
}

export const CoverLetter = ({isOpen, close, vacancyId, setReaction} : CoverLetterProps) => {
  const { reactToVacancy } = usePortalService();
  const [message, setMessage] = useState('')

  const replyHandler = async (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    const result = await reactToVacancy({
      vacancyId,
      message
    });
    if (result.success) {
      setReaction(true)
      close();
    }
  }

  return(
    <StyledModal title="Сопроводительное письмо" open={isOpen}
      footer={[
        <Button onClick={close} style={{marginRight: '6px'}} key="back">
          Отмена
        </Button>,
        <Button type="primary" onClick={replyHandler} key="submit">
          Откликнуться
        </Button>
      ]}
      onCancel={close}>
      <TextArea rows={12} value={message} onChange={e => setMessage(e.target.value)}/>
    </StyledModal>
  )
}